"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Svg_1 = __importDefault(require("../Svg"));

var CreditCardMastercard = function CreditCardMastercard(_a) {
  var fill = _a.fill,
      props = __rest(_a, ["fill"]);

  return react_1.default.createElement(Svg_1.default, __assign({}, props, {
    viewBox: "0 0 32 10"
  }), react_1.default.createElement("defs", null, react_1.default.createElement("radialGradient", {
    id: "a",
    cx: "324.392",
    cy: "9.581",
    r: "2.708",
    gradientTransform: "translate(-1.297 0.027) scale(0.977 0.977)",
    gradientUnits: "userSpaceOnUse"
  }, react_1.default.createElement("stop", {
    offset: "0.006",
    stopColor: "#ffeedf"
  }), react_1.default.createElement("stop", {
    offset: "0.1",
    stopColor: "#ffe9d6"
  }), react_1.default.createElement("stop", {
    offset: "0.254",
    stopColor: "#ffddbd"
  }), react_1.default.createElement("stop", {
    offset: "0.449",
    stopColor: "#ffc995"
  }), react_1.default.createElement("stop", {
    offset: "0.676",
    stopColor: "#ffae5e"
  }), react_1.default.createElement("stop", {
    offset: "0.928",
    stopColor: "#ff8b19"
  }), react_1.default.createElement("stop", {
    offset: "1",
    stopColor: "#ff8104"
  }))), react_1.default.createElement("g", {
    transform: "translate(-1509 -325)"
  }, react_1.default.createElement("g", {
    transform: "translate(1135.657 321.633)"
  }, react_1.default.createElement("path", {
    fill: "url(#a)",
    d: "M386.206,8.381a2.633,2.633,0,0,0-2.681,2.582,2.678,2.678,0,1,0,2.681-2.582Z",
    transform: "translate(3.793 0.005)"
  }), react_1.default.createElement("path", {
    fill: "#00101d",
    d: "M374.783,8.449h-1.44v5.026h1.433a2.632,2.632,0,0,0,1.794-.579,2.537,2.537,0,0,0,.911-1.931A2.5,2.5,0,0,0,374.783,8.449Zm1.146,3.775a1.852,1.852,0,0,1-1.342.4h-.264V9.3h.264a1.824,1.824,0,0,1,1.342.406,1.688,1.688,0,0,1,.541,1.25A1.718,1.718,0,0,1,375.929,12.224Z",
    transform: "translate(0 0.031)"
  }), react_1.default.createElement("rect", {
    fill: "#00101d",
    width: "0.98",
    height: "5.026",
    transform: "translate(377.933 8.48)"
  }), react_1.default.createElement("path", {
    fill: "#00101d",
    d: "M379.7,10.4c-.589-.217-.762-.361-.762-.631,0-.317.307-.557.73-.557a1.02,1.02,0,0,1,.792.406l.512-.67a2.195,2.195,0,0,0-1.477-.559,1.476,1.476,0,0,0-1.567,1.44c0,.693.316,1.047,1.235,1.378a3.9,3.9,0,0,1,.678.287.6.6,0,0,1,.3.52.716.716,0,0,1-.762.708,1.16,1.16,0,0,1-1.071-.67l-.631.611a1.951,1.951,0,0,0,1.74.957,1.622,1.622,0,0,0,1.732-1.651C381.144,11.17,380.813,10.808,379.7,10.4Z",
    transform: "translate(1.612 0.008)"
  }), react_1.default.createElement("path", {
    fill: "#00101d",
    d: "M380.426,11a2.6,2.6,0,0,0,2.653,2.623,2.7,2.7,0,0,0,1.23-.294V12.172a1.569,1.569,0,0,1-1.185.549,1.643,1.643,0,0,1-1.688-1.734,1.671,1.671,0,0,1,1.643-1.725,1.648,1.648,0,0,1,1.23.565V8.674a2.5,2.5,0,0,0-1.206-.307A2.643,2.643,0,0,0,380.426,11Z",
    transform: "translate(2.639 0)"
  }), react_1.default.createElement("path", {
    fill: "#00101d",
    d: "M389.7,11.825l-1.342-3.376h-1.07l2.133,5.155h.527l2.171-5.155h-1.062Z",
    transform: "translate(5.194 0.031)"
  }), react_1.default.createElement("path", {
    fill: "#00101d",
    d: "M391.129,13.475h2.781v-.851h-1.8V11.266h1.733v-.851h-1.733V9.3h1.8V8.449h-2.781Z",
    transform: "translate(6.626 0.031)"
  }), react_1.default.createElement("path", {
    fill: "#00101d",
    d: "M396.858,9.933c0-.942-.646-1.484-1.777-1.484h-1.455v5.026h.98v-2.02h.129l1.356,2.02H397.3l-1.584-2.118A1.337,1.337,0,0,0,396.858,9.933Zm-1.967.829h-.286V9.24h.3c.611,0,.943.257.943.745C395.851,10.49,395.519,10.762,394.892,10.762Z",
    transform: "translate(7.557 0.031)"
  }), react_1.default.createElement("path", {
    fill: "#1f191a",
    d: "M396.569,8.759c0-.088-.059-.136-.166-.136h-.143v.443h.1V8.893l.123.173h.132l-.147-.184A.121.121,0,0,0,396.569,8.759Zm-.185.06h-.019V8.7h.021c.052,0,.078.019.078.056S396.436,8.819,396.384,8.819Z",
    transform: "translate(8.538 0.095)"
  }), react_1.default.createElement("path", {
    fill: "#1f191a",
    d: "M396.484,8.5a.387.387,0,1,0,.382.387A.385.385,0,0,0,396.484,8.5Zm0,.7a.317.317,0,1,1,.3-.316A.312.312,0,0,1,396.482,9.205Z",
    transform: "translate(8.478 0.05)"
  }))));
};

CreditCardMastercard.displayName = 'CreditCardMastercard';
exports.default = CreditCardMastercard;